import { Box, Card, IconButton, Typography, useTheme } from '@mui/material'
import { useState, useEffect } from 'react'
import ReactPlayer from 'react-player'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';

const CardUploadFile = ({item,onDeleted}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [tipo, setTipo] = useState(null)
    const [esImagen, setEsImagen] = useState(false)
    const [esVideo, setEsVideo] = useState(false)
    const [esDocumento, setEsDocumento] = useState(false)

    useEffect(() => {
        const fileName = item?.path || item?.name || '';
        const tipe = fileName?.split('.');
        if(tipe?.length > 0){
            const extension = tipe[tipe?.length - 1]?.toLowerCase();
            setTipo(extension);
            
            // Clasificar el tipo de archivo
            const imageExtensions = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'svg', 'webp'];
            const videoExtensions = ['wmv', 'mp4', 'avi', 'mov', 'mkv', 'flv'];
            const docExtensions = ['pdf', 'doc', 'docx', 'txt', 'xls', 'xlsx', 'ppt', 'pptx'];
            
            setEsImagen(imageExtensions.includes(extension));
            setEsVideo(videoExtensions.includes(extension));
            setEsDocumento(docExtensions.includes(extension));
        }
    }, [item])

    const getFileIcon = () => {
        if (tipo === 'pdf') return <PictureAsPdfIcon sx={{ fontSize: 36, color: '#e53935' }} />;
        if (['doc', 'docx'].includes(tipo)) return <DescriptionIcon sx={{ fontSize: 36, color: '#1976d2' }} />;
        if (['xls', 'xlsx'].includes(tipo)) return <DescriptionIcon sx={{ fontSize: 36, color: '#43a047' }} />;
        if (['txt', 'plain'].includes(tipo)) return <DescriptionIcon sx={{ fontSize: 36, color: '#757575' }} />;
        return <InsertDriveFileIcon sx={{ fontSize: 36, color: '#9e9e9e' }} />;
    }

    const getFileSize = () => {
        if (item?.size) {
            const kb = item.size / 1024;
            if (kb < 1024) return `${kb.toFixed(1)} KB`;
            return `${(kb / 1024).toFixed(1)} MB`;
        }
        return '';
    }

    return (
        <Box sx={{ position: 'relative' }}>
            {esVideo ? (
                <Card sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    display: 'flex',
                    flexDirection: 'column',
                    p: 1,
                    borderRadius: 2,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                        boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                        transform: 'translateY(-1px)'
                    }
                }}>
                    <Box sx={{ 
                        borderRadius: 1.5, 
                        overflow: 'hidden',
                        mb: 0.5,
                        background: '#000'
                    }}>
                        <ReactPlayer
                            key={item?.id}
                            url={item?.preview}
                            width='100%'
                            height='80px'
                            controls
                        />
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <VideoLibraryIcon sx={{ color: '#fff', fontSize: 16 }} />
                        <Typography 
                            sx={{
                                color: '#fff',
                                fontSize: 11,
                                fontWeight: 500,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                flex: 1
                            }}
                        >
                            {item?.path || item?.name}
                        </Typography>
                    </Box>
                    {getFileSize() && (
                        <Typography sx={{ color: 'rgba(255,255,255,0.7)', fontSize: 9, mt: 0.25 }}>
                            {getFileSize()}
                        </Typography>
                    )}
                    {onDeleted && (
                        <IconButton 
                            sx={{
                                position: 'absolute',
                                top: 4,
                                right: 4,
                                background: 'rgba(255,255,255,0.95)',
                                boxShadow: 1,
                                width: 26,
                                height: 26,
                                '&:hover': {
                                    background: '#ffebee',
                                    transform: 'scale(1.1)'
                                },
                                transition: 'all 0.2s ease'
                            }} 
                            onClick={() => onDeleted(item)}
                        >
                            <DeleteOutlineOutlinedIcon sx={{ color: '#e53935', fontSize: 18 }} />
                        </IconButton>
                    )}
                </Card>
            ) : esImagen ? (
                <Card sx={{ 
                    background: isDarkMode ? '#1F2A40 !important' : '#fff !important',
                    display: 'flex',
                    flexDirection: 'column',
                    p: 1,
                    borderRadius: 2,
                    boxShadow: isDarkMode ? '0 2px 8px rgba(0,0,0,0.2)' : '0 2px 8px rgba(0,0,0,0.08)',
                    transition: 'all 0.2s ease',
                    border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e0e0e0',
                    '&:hover': {
                        boxShadow: isDarkMode ? '0 4px 12px rgba(0,0,0,0.3)' : '0 4px 12px rgba(0,0,0,0.15)',
                        transform: 'translateY(-1px)',
                        borderColor: isDarkMode ? '#64B5F6' : '#1976d2'
                    }
                }}>
                    <Box sx={{ 
                        borderRadius: 1.5, 
                        overflow: 'hidden',
                        mb: 0.5,
                        background: isDarkMode ? '#2d3a52' : '#f5f5f5',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: 80
                    }}>
                        <img
                            key={item?.id}
                            src={item?.preview}
                            alt={item?.path || item?.name}
                            style={{
                                maxWidth: '100%',
                                maxHeight: '100%',
                                objectFit: 'contain'
                            }}
                        />
                    </Box>
                    <Typography 
                        sx={{
                            color: isDarkMode ? '#e0e0e0' : '#424242',
                            fontSize: 11,
                            fontWeight: 500,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {item?.path || item?.name}
                    </Typography>
                    {getFileSize() && (
                        <Typography sx={{ color: isDarkMode ? '#b0bec5' : '#9e9e9e', fontSize: 9, mt: 0.25 }}>
                            {getFileSize()} • {tipo?.toUpperCase()}
                        </Typography>
                    )}
                    {onDeleted && (
                        <IconButton 
                            sx={{
                                position: 'absolute',
                                top: 4,
                                right: 4,
                                background: isDarkMode ? 'rgba(31,42,64,0.95)' : 'rgba(255,255,255,0.95)',
                                boxShadow: 1,
                                width: 26,
                                height: 26,
                                '&:hover': {
                                    background: isDarkMode ? '#422020' : '#ffebee',
                                    transform: 'scale(1.1)'
                                },
                                transition: 'all 0.2s ease'
                            }} 
                            onClick={() => onDeleted(item)}
                        >
                            <DeleteOutlineOutlinedIcon sx={{ color: '#e53935', fontSize: 18 }} />
                        </IconButton>
                    )}
                </Card>
            ) : (
                <Card sx={{ 
                    background: isDarkMode ? 'linear-gradient(135deg, #1F2A40 0%, #2d3a52 100%)' : 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    p: 1,
                    borderRadius: 2,
                    boxShadow: isDarkMode ? '0 2px 8px rgba(0,0,0,0.2)' : '0 2px 8px rgba(0,0,0,0.08)',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                        boxShadow: isDarkMode ? '0 4px 12px rgba(0,0,0,0.3)' : '0 4px 12px rgba(0,0,0,0.15)',
                        transform: 'translateY(-1px)'
                    }
                }}>
                    <Box sx={{ 
                        mb: 0.5,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: 50
                    }}>
                        {getFileIcon()}
                    </Box>
                    <Typography 
                        sx={{
                            color: isDarkMode ? '#e0e0e0' : '#424242',
                            fontSize: 11,
                            fontWeight: 600,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            textAlign: 'center',
                            width: '100%'
                        }}
                    >
                        {item?.path || item?.name}
                    </Typography>
                    {getFileSize() && (
                        <Typography sx={{ color: isDarkMode ? '#b0bec5' : '#757575', fontSize: 9, mt: 0.25, textAlign: 'center' }}>
                            {getFileSize()} • {tipo?.toUpperCase()}
                        </Typography>
                    )}
                    {onDeleted && (
                        <IconButton 
                            sx={{
                                position: 'absolute',
                                top: 4,
                                right: 4,
                                background: isDarkMode ? 'rgba(31,42,64,0.95)' : 'rgba(255,255,255,0.95)',
                                boxShadow: 1,
                                width: 26,
                                height: 26,
                                '&:hover': {
                                    background: isDarkMode ? '#422020' : '#ffebee',
                                    transform: 'scale(1.1)'
                                },
                                transition: 'all 0.2s ease'
                            }} 
                            onClick={() => onDeleted(item)}
                        >
                            <DeleteOutlineOutlinedIcon sx={{ color: '#e53935', fontSize: 18 }} />
                        </IconButton>
                    )}
                </Card>
            )}
        </Box>
    )
}

export default CardUploadFile